import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Footer } from "@components";
import { post } from "@utils/axios_api";
import { useSignup } from "@context/SignupContext";


const Verify = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { setVerified } = useSignup();

  const handleVerify = async () => {
    setLoading(true);
    setError(null);
    try {
        const response = await post('/verifyIdentity', {

        });

      if (response.status) {
        setVerified(true);
        const { name, birthdate } = response.result;
        navigate('/signup', { userdata: { name, birthdate } });
      } else {
        setError(response.message || '본인인증에 실패했습니다.');
      }
    } catch (err) {
      console.error('본인인증 중 오류 발생:', err);
      setError('본인인증 중 오류가 발생했습니다. 다시 시도해주세요.');
    } finally {
      setLoading(false);
    }
  };


  
  return (
    <main id="main" className="mainpage">
      <div>
        <div className="section main-contact">
          <div className="sub-tit-bg">
            <div className="container sub-h">
              <div className="sub-tit-01">
                <img src="/img/ico-home.png" alt="home" />
                회원가입 | 본인인증
              </div>
            </div>
          </div>

          <div className="sub-container">
            <div className="sub-layout">
              <div className="sub-contact">
                <h3 className="border-bt">회원가입</h3>
                  <ul className="member-box">
                    <li>
                      <span>1</span>약관동의
                    </li>
                    <li>
                      <span className="on">2</span>본인인증
                    </li>
                    <li>
                      <span >3</span>정보입력
                    </li>
                  </ul>
                  <div className="text-cent">
                  <button
                    type="button"
                    className="btn btn-blue mt30 btn-big"
                    onClick={handleVerify}
                    disabled={loading}
                  >
                    {loading ? '본인인증 중...' : '본인인증'}
                  </button>
                  {error && <p className="error-text" style={{ color: 'red', marginTop: '10px' }}>{error}</p>}
               
                  </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </main>

  );
};

export default Verify;
